import React from 'react'

export default function Home({children}) {
    return (
        <div className="home">
            {children}
        </div>
    )
}
